"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gauge = _interopRequireDefault(require("@amzn/meridian-tokens/component/gauge"));

var _theme = require("../theme");

var _needle = _interopRequireDefault(require("../_needle"));

var _scale = _interopRequireDefault(require("./_scale"));

var _percentBetweenValues = _interopRequireDefault(require("./../_utils/percent-between-values"));

var _functional = require("./../_utils/functional");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _emotion.css)({
  position: "relative",
  "& > div[mdn-circular-children]": {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
  }
});
var transitionStyle = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    transition: "".concat(t("value", "motionDuration"), " ").concat(t("value", "motionFunction"))
  });
});

var CircularGauge = function CircularGauge(props) {
  var width = props.width,
      value = props.value,
      minValue = props.minValue,
      maxValue = props.maxValue,
      open = props.open,
      needle = props.needle;
  var t = (0, _theme.useTheme)(_gauge["default"], "gauge");
  var trackWidth = (0, _react.useMemo)(function () {
    return props.trackWidth || t("trackWidth", "circular");
  }, [t, props.trackWidth]); // If a value is present, calculates the angle to draw it at

  var valuePercentage = value ? (0, _percentBetweenValues["default"])(value, minValue, maxValue) : null; // Calculates the circumference of the circle we use to stroke/style the value.
  // This calculation could be avoided if we used a pathLength approach where
  // the pathLength is set to 360. Unfortunately, pathLength is not fully supported
  // in webkit/Safari: https://bugs.webkit.org/show_bug.cgi?id=72401

  var strokeCircumference = (0, _react.useMemo)(function () {
    return 2 * Math.PI * ((width - trackWidth) / 2) * (open ? 0.75 : 1);
  }, [width, trackWidth, open]);
  var rotation = (0, _react.useMemo)(function () {
    return !open ? "rotate(-90, 0,0)" : "rotate(135, 0,0)";
  }, [open]);

  var _useMemo = (0, _react.useMemo)(function () {
    if (!needle || !open) return [90, 450];else return [-45, 225];
  }, [open, needle]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
      needleStartAngle = _useMemo2[0],
      needleEndAngle = _useMemo2[1];

  var _useMemo3 = (0, _react.useMemo)(function () {
    if (!open) return [90, 450];else return [-45, 225];
  }, [open]),
      _useMemo4 = (0, _slicedToArray2["default"])(_useMemo3, 2),
      scaleStartAngle = _useMemo4[0],
      scaleEndAngle = _useMemo4[1];

  var scale = props.divisions && open;
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "img",
    className: styles,
    "aria-labelledby": props["aria-labelledby"],
    "aria-describedby": props["aria-describedby"],
    "aria-label": props["aria-label"],
    title: props["aria-label"]
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: width,
    viewBox: "-".concat(width / 2, " -").concat(width / 2, " ").concat(width, " ").concat(width)
  }, scale ? /*#__PURE__*/_react["default"].createElement(_scale["default"], {
    radius: width / 2,
    startAngle: scaleStartAngle,
    endAngle: scaleEndAngle,
    divisions: props.divisions,
    subdivisions: props.subdivisions,
    circumference: strokeCircumference,
    trackWidth: trackWidth,
    minValue: minValue,
    maxValue: maxValue,
    renderLabel: props.renderDivisionLabels
  }) : null, /*#__PURE__*/_react["default"].createElement("circle", {
    cy: 0,
    cx: 0,
    r: (width - trackWidth) / 2,
    fill: "none",
    transform: rotation,
    stroke: props.trackColor || t("trackColor"),
    strokeWidth: trackWidth,
    strokeDasharray: "".concat(strokeCircumference, " ").concat(strokeCircumference),
    className: transitionStyle(t)
  }), value ? /*#__PURE__*/_react["default"].createElement("circle", {
    cy: 0,
    cx: 0,
    r: (width - trackWidth) / 2,
    transform: rotation,
    fill: "none",
    stroke: props.fillColor || t("valueColor"),
    strokeWidth: trackWidth,
    strokeDasharray: "".concat(strokeCircumference * valuePercentage, " ").concat(strokeCircumference * 2),
    className: transitionStyle(t)
  }) : null, needle && open ? /*#__PURE__*/_react["default"].createElement(_needle["default"], {
    percentage: valuePercentage,
    y: 0,
    x: 0,
    startAngle: needleStartAngle,
    endAngle: needleEndAngle,
    length: scale || width <= 100 ? width / 4 : width / 3
  }) : null), props.children ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-circular-children": ""
  }, props.children) : null);
};

CircularGauge.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The gauge's maximum value.
   */
  maxValue: _propTypes["default"].number.isRequired,

  /**
   * The gauge's minimum value.
   */
  minValue: _propTypes["default"].number.isRequired,

  /**
   * The gauge's value.
   */
  value: _propTypes["default"].number.isRequired,

  /**
   * The id of an element that acts as a description for the visualization.
   * We recommend displaying a Text component with a description for
   * the visualization and setting this prop to the id of that Text.
   *
   * @since 5.20.0
   */
  "aria-describedby": _propTypes["default"].string,

  /**
   * A label for the visualization. We recommend using `aria-labelledby` and
   * `aria-describedby` if possible, otherwise this can be set if there is no
   * visible element that labels the visualization.
   */
  "aria-label": _propTypes["default"].string,

  /**
   * The id of an element that acts as a label, heading, or title for the
   * visualization. We recommend displaying a Heading component with a title for
   * the visualization and setting this prop to the id of that Heading.
   */
  "aria-labelledby": _propTypes["default"].string,

  /**
   * Renders a node (most likely a [Text](/components/text/) component) centered inside the gauge.
   */
  children: _propTypes["default"].node,

  /**
   * Creates a number tick marks and labels along the inside of the gauge. For example,
   * if `divisions={2}` and min/max values are 0 and 100 respectively, the gauge will
   * be split into two divisions with three tick marks and labels would appearing
   * at the 0, 50, and 100 positions. Only available when the `open` prop is set to `true`.
   */
  divisions: _propTypes["default"].number,

  /**
   * The gauge's fill color representing the value.
   */
  fillColor: _propTypes["default"].string,

  /**
   * Set to `true` to render a needle that points towards the value. Only available
   * when the `open` prop is set to `true`
   */
  needle: _propTypes["default"].bool,

  /**
   * CircularGauge comes in two flavors, a full closed circle or a partial open circle.
   * Closed circle gauges begin filling their track from the top/center position.
   * Open circular gauges begin filling their track from the bottom/left position
   * and can render a needle and/or tick marks with labels.
   */
  open: _propTypes["default"].bool,

  /**
   * A function used to render the division labels. The function is passed a single
   * object with three key/values pairs.
   *
   * `index`: the index of the tick mark (not including subdivisions) along the gauge
   *
   * `percent`: the position along the gauge as a percentage float 0~1 (inclusive)
   *
   * `value`: the calculated value at the position along the gauge
   */
  renderDivisionLabels: _propTypes["default"].func,

  /**
   * Creates tick marks within divisions. Only available when the `divisions` prop
   * is also set.
   */
  subdivisions: _propTypes["default"].number,

  /**
   * The gauge's fill color for the track.
   */
  trackColor: _propTypes["default"].string,

  /**
   * The width of the track.
   */
  trackWidth: _propTypes["default"].number,

  /**
   * Set the width of the gauge.
   */
  width: _propTypes["default"].number
} : {};
CircularGauge.defaultProps = {
  needle: false,
  width: 180,
  open: false
};
var _default = CircularGauge;
exports["default"] = _default;